module.exports = __webpack_public_path__ + "img/4.ef2f339f.jpg";